import { type ViewBlockAbstract } from '@lighthouse/core'
import { useAtomData } from '@lighthouse/shared'
import { useCallback, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useUpdateEffect } from 'react-use'

import { blockCreatingListAtom, blockUpdateListAtom } from '@/atoms/page/state'

import type { FetchViewDataPayload } from '../types'

interface UseTableConfigPayload {
    blockData: ViewBlockAbstract
    getGroupRecordCount?: () => Promise<void>
    fetchViewData: (params: FetchViewDataPayload) => Promise<void>
    ignorePaginationConfig?: boolean
}

export const useConfigure = (props: UseTableConfigPayload) => {
    const { blockData, getGroupRecordCount, fetchViewData, ignorePaginationConfig } = props
    const { id, config } = blockData
    const { pagination, canPaginate } = config
    const urlRef = useRef(false)
    const urlLocation = useLocation()

    // findNormalOrSyncBlock
    const hasNeedUpdateYet = useAtomData(
        blockUpdateListAtom,
        useCallback(s => s.includes(id), [id])
    )

    const hasNotCreatedYet = useAtomData(
        blockCreatingListAtom,
        useCallback(s => s.includes(id), [id])
    )

    useEffect(() => {
        getGroupRecordCount?.()
    }, [getGroupRecordCount])

    useEffect(() => {
        if (hasNotCreatedYet) {
            return
        }
        fetchViewData({ pageNum: 1 })
    }, [hasNotCreatedYet, fetchViewData])

    // 切换回页面进行数据请求
    useUpdateEffect(() => {
        if (urlLocation.pathname.includes('/page')) {
            if (urlRef.current) {
                fetchViewData({ pageNum: 1 })
            }
            urlRef.current = false
        }
        urlRef.current = true
    }, [urlLocation.pathname])

    // 当数据查看器进行增删改时 需要重载
    useUpdateEffect(() => {
        if (hasNeedUpdateYet) {
            fetchViewData({ pageNum: 1 })
        }
    }, [hasNeedUpdateYet])

    // 当分页栏开启关闭需要重新加载数据
    useUpdateEffect(() => {
        fetchViewData({
            pageNum: 1
        })
    }, [ignorePaginationConfig ? undefined : pagination.pageSize, ignorePaginationConfig ? undefined : canPaginate])
}
